var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-input-radio-group"},_vm._l((_vm.model.options),function(option,i){return _c('div',{key:i,staticClass:"ui-input-radio-group__item"},[_c('ui-input-radio-item',{attrs:{"model":{ ...option },"value":_vm.value,"name":_vm._uid + '-' + i},on:{"change":_vm.changeHandler,"focus":_vm.focusHandler,"blur":_vm.blurHandler}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }